import React, { useCallback, useEffect, useState } from "react";
//import { Cookies, CookiesProvider, useCookies } from "react-cookie";
import { Outlet, useNavigate } from "react-router-dom";
import { Footer } from "./Footer";
import { LeftNav } from "./LeftNav";
import { Topnav } from "./TopNav";
import Cookies from "js-cookie";

const DashBoard = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
    }, 1000);
  }, [setIsLoading]);

  useEffect(() => {
    if (!Cookies.get("newJwt")) {
      return navigate("/");
    }
  }, [navigate]);

  return (
    
    <div className="wrapper">
      <LeftNav />
      {Cookies.get("newJwt") && isLoading ? (
        <div className="main dashBoardLayout">
          <Topnav />
          <main className="content">
            <div className="container-fluid">
              <div className="row">
                <Outlet />
              </div>
            </div>
          </main>
          {/* <Footer /> */}
        </div>
      ) : (
        <div className="splash active">
          <div className="splash-icon"></div>
        </div>
      )}
    </div>
   
  );
};

export { DashBoard };
